module.exports = __webpack_public_path__ + "static/img/ceiling.83661f87.png";